const tileWorkerService = {
  title: "Tile Worker",
  icon: "🟫",
  shortDescription:
    "Tile replacement, minor tile work, grout repair, and flooring correction support.",
  longDescription:
    "Book tile work support for small replacement jobs, grout correction, levelling support, and finish-area fixes. Larger jobs may require inspection.",
  consultationNote:
    "Area-based tile estimation and base preparation may require site inspection.",
  responsePromise:
    "Assignment depends on task complexity, area size, and worker fit.",
  warrantyPolicy:
    "Revisit support depends on tile type, adhesion conditions, and usage exposure.",
  subServices: [
    {
      id: "tile-single-replacement",
      title: "Single / Minor Tile Replacement",
      icon: "🧱",
      group: "Replacement",
      description:
        "Replace one or a few broken/damaged tiles where base condition allows.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "tile-grout-repair",
      title: "Grout Repair",
      icon: "🪣",
      group: "Repair",
      description:
        "Repair grout lines or minor finish gaps between existing tiles.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "tile-levelling-support",
      title: "Minor Tile Levelling Support",
      icon: "📏",
      group: "Correction",
      description:
        "Correct small level difference issues or prep areas for improved tile finish.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "tile-inspection",
      title: "Tile Work Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for tile replacement, floor issue, bathroom tile damage, or estimate planning.",
      basePrice: 299,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default tileWorkerService;